<div class="list-group-item-v4"
     [ngClass]="{'active': isActive}" (click)="showSelections()">
    <div class="list-group-item-content">
        <ng-content></ng-content>
        <span *ngIf="!isEnum && showIcon">
            <i class="fas fa-arrows-alt move-icon"></i>
        </span>
        <span *ngIf="isEnum && showIcon">
            <i *ngIf="isActive" class="fas fa-arrows-alt move-icon"></i>
            <i *ngIf="!isActive" class="fas fa-angle-right move-icon"></i>
        </span>
    </div>
</div>
<div class="selections" *ngIf="isEnum && isActive">
    <div class="list-group-item-v4" *ngFor="let item of selections">
        <span class="list-group-item-content"
             dnd-draggable
             [dndDraggable]="{'label': item, 'value': idFromTitle(item), 'name': item, 'id': item, 'type': 'token' }" [dndEffectAllowed]="effectAllowed">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
              <span>
                  {{item}}
              </span>
                </div>
            </div>
        </span>
        <span>
            <i class="fas fa-arrows-alt move-icon"></i>
        </span>
    </div>
</div>
<div class="selections" *ngIf="catalogItems.length && isActive">
    <div class="list-group-item-v4" *ngFor="let item of catalogItems">
        <span class="list-group-item-content"
              dnd-draggable
              [dndDraggable]="{'label': item.value, 'value': idFromTitle(item.value), 'name': item.value, 'id': item.id, 'type': 'token' }" [dndEffectAllowed]="effectAllowed">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
              <span>
                  {{item.value}}
              </span>
                </div>
            </div>
        </span>
        <span>
            <i class="fas fa-arrows-alt move-icon"></i>
        </span>
    </div>
</div>